import { gql } from '@apollo/client';
export const GET_STAFFING_DASHBOARD_DATA = gql`
  query GetTeamProjects($searchString: String) {
    baseProjects(searchString: $searchString) {
      id
      legacyId
      name
      alias
      projectManager
      staffingCoordinator
      description
      budget {
        id
        startDate
        endDate
        billingType
        fte
      }
      isArchived
      accountData {
        accountName
        accountId
        ownerAlias
      }
      team {
        id
        location
        projectId
        type
        updatedAt
        members {
          id
          teamId
          slotId
          assignmentId
          employeeAlias
          positionId
          technologyId
          competencyLevel
          fte
          role
          isProbation
          isBackup
          isBench
          startDate
          endDate
          noteText
          createdAt
          updatedAt
        }
        expectedStructure {
          id
          teamId
          positionId
          technologyId
          competencyLevel
          requiredFte
          requiredRole
          description
        }
      }
      staffingRisk {
        id
        projectId
        priority
        issues {
          id
          description
          status
          targetPriority
          systemIssueType
          staffingRiskId
        }
        followUps {
          id
          description
          followUpDate
          status
          createdAt
          updatedAt
        }
      }
      criticalPeriods {
        id
        projectId
        title
        description
        startDate
        endDate
      }
      upcomingChanges {
        id
        projectId
        type
        status
        plannedStart
        plannedEnd
        isPrivate
        items {
          id
          upcomingChangeId
          fromEmployeeAlias
          toEmployeeAlias
          relatedAssignmentId
          comment
        }
        createdBy
        updatedBy
        createdAt
        updatedAt
      }
      staffingNote {
        id
        projectId
        dateTime
        author
        noteText
        attachmentPaths
      }
      accessInfo {
        id
        sections {
          section
          allowedActions
        }
      }
      teamChart {
        fteRate {
          id
          projectId
          projectName
          startDate
          avgRequiredFte
          staffingRate
          avgActualFte
        }
        tenureDistribution {
          projectName
          durationRange
          employeeCount
          employeePercent
        }
        averageTenure {
          id
          projectId
          projectName
          endMonth
          averageTenure
        }
      }
      assignments {
        id
        employeeAlias
        positionId
        technologyId
        isVirtual
        isBackup
        isSpof
        isBench
        projectId
        projectName
        fromDate
        toDate
        minPercent
        maxPercent
        slotId
        status
        membershipRole
        competencyLevel
        isProbation
        noteText
      }
      engagement {
        id
        crmId
        name
        accountId
        expectedStartDate
        status
        relatedProjectId
        rawProjectId
        deletedAt
      }
    }
  }
`;
